import {SlideData} from "./SlideData";

import labubu from "../../assets/img/party/crazy-labyby-1.webp";
import crazyLabubu from "../../assets/img/party/crazy-labyby.webp";
import footbol from '../../assets/img/party/footbol.webp';
import gameCalmar from "../../assets/img/party/game-calmar.webp";
import games from "../../assets/img/party/gamers.webp";
import grinch from "../../assets/img/party/grinch.webp";
import kvidich from "../../assets/img/party/kvidich.webp";
import karamelka from "../../assets/img/party/lkaramelka.webp";
import ferm from "../../assets/img/party/my-ferm.webp";
import neon from "../../assets/img/party/neion.webp";
import nevmor from "../../assets/img/party/nevmor.webp";
import animators from "../../assets/img/party/animators.webp";
import showGigant from "../../assets/img/party/show-gigant.webp";
import  paleontolog from "../../assets/img/party/paleontologist.webp";
import frostyMagic from "../../assets/img/party/frosty-magic.webp";
import barby from "../../assets/img/party/barbie.webp";
import batmen from "../../assets/img/party/batmen.webp";
import edinorog from "../../assets/img/party/edinirog.webp";
import challengeParty from "../../assets/img/party/challenge-party.webp";
import pajamaParty from "../../assets/img/party/pajama-party.webp";
import dino  from "../../assets/img/party/dino.webp";
import piratParty from "../../assets/img/party/pirat-paty.webp";
import mavis from "../../assets/img/party/mavis.webp";
import superCat from "../../assets/img/party/super-cat.webp";
import spider from "../../assets/img/party/spider.webp";
import magicForest from "../../assets/img/party/magic-forest.webp";
import ladyBag from "../../assets/img/party/lady-bag.webp";
import stich from "../../assets/img/party/stich.webp";

// @ts-ignore
export const Slides = (): SlideData[] => [
    {
        image: labubu,
        title: 'Экспресс‑поздравление от Лабубу',
        price: '3 000 руб.',
        description:
            'Хотите устроить настоящий вау‑момент, но без долгих программ? Теперь это возможно — с экспресс‑поздравлением от ростовой куклы Лабубу.',
        alt: 'Labyby',
    }, {
        image: crazyLabubu,
        title: 'Сумасшедший учёный и лабуба',
        price: 'от 7 400 руб.',
        description:
            'Сумасшедший учёный, пушистый гость из другой планеты и ваши дети — команда юных исследователей. Тайная миссия, смешные испытания и творческая финальная зона — всё безопасно и по‑взрослому уютно. Праздник, от которого дети в восторге, а родители спокойно пьют свой кофе.',
        alt: 'Crazy',
    },
    {
        image: footbol,
        title: 'Футбольная вечеринка',
        price: 'от 4 400 ₽ / час',
        description:
            'Футбольная вечеринка — когда каждый ребёнок становится звездой поля! Мбаппе, пенальти, эмоции, викторины, трюки и победный танец! Именинник — капитан. Гости — команда мечты.',
        alt: 'Футбол',
    },
    {
        image: kvidich,
        title: 'Квиддич, лови мяч, а не выгорание',
        price: 'от 4 400 ₽ / час',
        description:
            'Магия существует. Особенно на Дне Рождения. И команда Вау.. Праздник!!! готова доказать это вашему ребёнку. Мы проведём для него и гостей волшебную вечеринку в стиле Хогвартса, где: дети пройдут распределение по факультетам, освоят заклинания, сразятся в волшебной игре, сварят светящиеся зелья удачи и встретятся с… весьма загадочными героями.',
        alt: 'Квидич',
    },
    {
        image: gameCalmar,
        title: 'Та самая игра',
        price: 'от 4 400 ₽ / час',
        description: 'Дорогие родители, ваше чадо готово к вызову, который навсегда останется в его\n' +
            '                воспоминаниях? Мы подготовили не просто развлечение, а целое приключение! Участники попадут в загадочный\n' +
            '                мир, где их ждет череда испытаний, каждое из которых проверяет их ловкость, смекалку и командный\n' +
            '                дух.',

        alt: 'Та самая игра',
    },
    {
        image: games,
        title: 'Геймеры',
        price: 'от 5 000 ₽ / час',
        description: 'Эта вечеринка — идеальный выбор для детей, которые обожают технологии, любят\n' +
            '                соревноваться, проявлять ловкость и включать смекалку. В течение часа ребята окажутся внутри того самого\n' +
            '                «виртуального мира», где всё настоящее — эмоции, движение, радость и восторг.',
        alt: 'Геймеры',
    },
    {
        image: grinch,
        title: 'ГринЧеринка',
        price: 'от 4 400 ₽ / час',
        description: 'Родители, хотите подарить вашему ребенку самый необычный и веселый День Рождения?\n' +
            '                Добро пожаловать на ГринЧеринку – праздник, где всё идет не так, как планировалось, но точно так, как\n' +
            '                мечтается!',
        alt: 'ГринЧеринка',
    },
    {
        image: ferm,
        title: 'Моя ферма',
        price: 'от 4 400 ₽ / час',
        description: 'Хочешь удивить своего ребёнка ярким и веселым праздником?\n' +
            '                Тогда фермерская вечеринка с Огурчиком и Цветочком – это то, что вам нужно!',
        alt: 'Моя ферма',
    },
    {
        image: karamelka,
        title: 'Вечеринки для праздников',
        price: 'от 4 400 ₽ / час',
        description: 'Миу-миу-миу… кто это у нас тут праздник устроил?!\n' +
            '                    Если в вашем доме живёт маленький фанат «Трёх Котов» — у нас для вас нечто мяу-чудесное!\n' +
            '                    Мы отправились в волшебное путешествие вместе с Карамелькой, заглянули к бабушке на дачу, нашли кое-кого в сарае (не скажем кого 😼),\n' +
            '                    спасли ягодки, поймали бабочек и чуть не унеслись с пчёлами в цветочный улей!',
        alt: 'Вечеринки для праздников',
    },
    {
        image: neon,
        title: 'Неоновое путешествие',
        price: 'от 4 400 ₽ / час',
        description: 'МХочешь устроить своему ребёнку настоящую неоновую вечеринку?\n' +
            '                Добро пожаловать в удивительный мир Лунтианов!',
        alt: 'Неоновое путешествие',
    },
    {
        image: nevmor,
        title: 'Путешествие в Невермор',
        price: 'от 4 400 ₽ / час',
        description: 'Если ваш ребёнок в восторге от загадочных историй и необычных персонажей,\n' +
            '                то вечеринка с Уэнсдей – это точно для вас!',
        alt: 'Путешествие в Невермор',
    },
    {
        image: animators,
        title: 'Аниматор на выезд<',
        price: 'от 4 400 ₽ / час',
        description: 'Подарите ребенку чудо! Опытные аниматоры устроят для вашего малыша\n' +
            ' настоящий праздник, который запомнится надолго!\n' +
            ' Огромный выбор программ и персонажей.',
        alt: 'Аниматор на выезд',
    },
    {
        image: showGigant,
        title: 'Шоу гигантских подушек',
        price: 'от 5 500 ₽ / час',
        description: 'Хотите сделать ваш праздник незабываемым? Мы предлагаем уникальную\n' +
            'возможность окунуться в мир веселья и смеха с нашей интерактивной программой!',
        alt: 'Шоу гигантских подушек',
    },
    {
        image: paleontolog,
        title: 'Палеонтолог',
        price: 'от 4 400 ₽ / час',
        description: ' Наш веселый и отважный палеонтолог, изучая динозавров мелового периода потерял труд всей своей жизни.\n' +
            '                Ему нужна помощь!\n' +
            '                Ребята вместе с ним отправятся в путешествие на машине времени чтобы найти утерянную работу по изучению\n' +
            '                динозавров.\n' +
            '                Они пройдут множество испытаний, получат море положительных эмоций, а также поучаствуют в раскопках.',
        alt: 'Палеонтолог',
    },
    {
        image: frostyMagic,
        title: 'Морозное волшебство',
        price: 'от 4 400 ₽ / час',
        description: 'Эльза и Анна отправляются в таинственный лес.\n' +
            'Ребята узнают о волшебных духах леса, которые повелевают 4 стихиями, а также найдут пятый элемент.',
        alt: 'Морозное волшебство',
    },
    {
        image: barby,
        title: 'Хай, Барби!',
        price: 'от 4 400 ₽ / час',
        description: 'Барби вместе со своими новыми куколками отправляются в Барбиленд! Их ждет море эмоций, веселья и\n' +
            'забавных конкурсов!',
        alt: 'Хай, Барби!',
    },
    {
        image: batmen,
        title: 'Бэтмэн!',
        price: 'от 4 400 ₽ / час',
        description: 'Бэтмен в поиске приемника в свою команду. Он проверит ребят на силу, смекалку, ловкость!',
        alt: 'Бэтмэн!',
    },
    {
        image: edinorog,
        title: 'Волшебный мир единорогов',
        price: 'от 4 400 ₽ / час',
        description: 'Проказница Зефирка, подруга нашей единорожки Николь, спрятала именинный тортик!\n' +
            'Для того, чтобы отыскать самую любимую сладость Николь с ребятами должны будут разучить\n' +
            'волшебный танец, найти секретные послания с заданиями и выполнить их.',
        alt: 'Волшебный мир единорогов',
    },
    {
        image: challengeParty,
        title: 'Челлендж пати',
        price: 'от 5 000 ₽ / час',
        description: '"Челлендж Party" — это праздник, который перевернет представление о веселье!\n' +
            'Забудьте про скучные посиделки, ведь мы собрали самые популярные и веселые челленджи, \n' +
            'чтобы каждый ребенок почувствовал себя звездой шоу.',
        alt: 'Челлендж пати',
    },
    {
        image: pajamaParty,
        title: 'Пижамная вечеринка',
        price: 'от 4 400 ₽ / час',
        description: 'Каждая девочка мечтает устроить пижамную вечеринку с подружками дома, но,\n' +
            'к сожалению, нt всегда у родителей получается осуществить задуманное для\n' +
            'своих малышек… Не спешите расстраиваться! Мы знаем, как это исправить!',
        alt: 'Пижамная вечеринка',
    },
    {
        image: piratParty,
        title: 'Пиратская вечернинка',
        price: 'от 4 400 ₽ / час',
        description: 'Пиратка Сильвия собирает отважную команду юных пиратов\n' +
            'для поиска сундука\n' +
            'с сокровищами и золотыми дублонами! Сильвия и ее капитан Джек Воробей\n' +
            'удирали от злого пирата Черная Борода и разделились чтоб он их не настиг!',
        alt: 'Пиратская вечернинка',
    },
    {
        image: dino,
        title: 'Дино вечернинка',
        price: 'от 7 500 ₽ / час',
        description: 'Наш веселый и отважный палеонтолог, изучая динозавров \n' +
            '                    мелового периода потерял \n' +
            '                    труд всей своей жизни. Ему нужна помощь!\n' +
            '                    Ребята вместе с ним отправятся в путешествие на машине времени чтобы \n' +
            '                    найти утерянную работу по изучению динозавров. Они пройдут множество \n' +
            '                    испытаний, познакомятся с тираннозавриком, а также поучаствуют в раскопках.',
        alt: 'Дино вечернинка',
    },
    {
        image: mavis,
        title: 'Монстринский день рождения',
        price: 'от 4 400 ₽ / час',
        description: 'Мэйвис покажет деткам как отмечают свой день рождение\n' +
            'монстрики! Ребят ждет увлекательное путешествие в «иной» мир где много развлечений,\n' +
            'смеха, радости и различных забав!',
        alt: 'Монстринский день рождения',
    },
    {
        image: superCat,
        title: 'Лапы на готове. Супер кот',
        price: 'от 4 400 ₽ / час',
        description: 'Если твой ребёнок любит супергероев, то у нас есть просто фантастический\n' +
            ' вариант для праздника – вечеринка с Супер Котом!',
        alt: 'Лапы на готове. Супер кот',
    },
    {
        image: spider,
        title: 'Паутина веселья (Человек паук)',
        price: 'от 4 400 ₽ / час',
        description: 'Представь: супергерой приходит прямо на праздник, чтобы зажечь этот день\n' +
            'яркими эмоциями и сделать его незабываемым.',
        alt: 'Паутина веселья (Человек паук)',
    },
    {
        image: magicForest,
        title: 'Тайны Волшебного Леса',
        price: 'от 4 400 ₽ / час',
        description: 'Мы запустили новую волшебную программу “Тайны Волшебного Леса” — и она уже успела стать любимицей детей.\n' +
            'Почему? Потому что тут нет «просто игры».' +
            'Здесь — настоящее приключение, в которое ребёнок попадает всем сердцем.',
        alt: 'Тайны Волшебного Леса',
    },
    {
        image: ladyBag,
        title: 'Леди баг спасает День Рождения',
        price: 'от 4 400 ₽ / час',
        description: 'Супергеройское приключение для детей 4–8 лет\n' +
            'В этот день к детям приходит настоящая Леди Баг — яркая, добрая и очень живая.\n' +
            'Она появляется внезапно и сразу вовлекает ребят в увлекательное супергеройское приключение, где нужно помочь спасти праздник от проделок Бражника.',
        alt: 'Леди баг спасает День Рождения',
    },
    {
        image: stich,
        title: 'СТИЧ гавайская вечеринка',
        price: 'от 4 400 ₽ / час',
        description: 'Стич врывается на праздник с гавайским настроением и объявляет:\n' +
            '«Алоха! Сегодня вы — моя команда приключений!»\n' +
            'Что ждёт ребят:\n' +
            'Испытание “Островные носильщики”\n' +
            'Дети учатся переносить фрукты в огромных листьях, как настоящие жители джунглей.\n' +
            'Не уронить, не поссориться, дойти вместе — миссия командной радости.',
        alt: 'СТИЧ гавайская вечеринка',
    },


];
